export default __webpack_public_path__ + "static/media/T32.66f960d6.JPG";